import Header from "../components/Header";
import { useNavigate } from "react-router-dom";

function SAResources() {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="min-h-screen p-8 bg-gray-50">
        <button
          onClick={() => navigate("/home")}
          className="mb-6 inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 shadow-sm"
        >
          ← Back to Dashboard
        </button>

        <h1 className="text-4xl font-bold text-gray-800 mb-4">Separation Anxiety Resources</h1>

        <p className="text-lg text-gray-700 mb-6 max-w-3xl">
          Everything you need to support your dog through their SA journey with confidence and clarity.
        </p>

        <ul className="list-disc list-inside mb-8 text-gray-700 space-y-1">
          <li>Printable Training Logs</li>
          <li>Warm-Up Step Templates</li>
          <li>Supportive Calm Activities</li>
          <li>Success Criteria Examples</li>
          <li>Emergency Support Plan (PDF)</li>
          <li>SA Maintenance Resources</li>
        </ul>

        <div className="border border-dashed border-blue-300 p-6 text-center text-blue-700 rounded-lg bg-white shadow-sm">
          🔒 These materials are available to SA clients only.
        </div>
      </div>
    </>
  );
}

export default SAResources;
